import React, { useEffect, useState } from "react";
import "./styles.scss";
import formationsData from "../../../assets/data/formations";

import FormationCell from "../../../components/FormationCell";
import clsx from "clsx";
import { TypeFormation } from "../../../models/Formation";
import {
  faBook,
  faCrown,
  faSwatchbook
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type FormationsSectionProps = {
  openIndicateursPerformanceModal: any;
  openFinancementsModal: any;
};

const FormationsSection: React.FC<FormationsSectionProps> = ({
  openIndicateursPerformanceModal,
  openFinancementsModal
}) => {
  const [selectSection, setSelectSection] = useState(0);

  const sections = [
    {
      label: "Formations catalogue",
      type: TypeFormation.FormationCatalogue,
      icon: faBook
    },
    {
      label: "Formations spécifiques",
      type: TypeFormation.FormationSpecifique,
      icon: faSwatchbook
    },
    {
      label: "Formations tendance",
      type: TypeFormation.FormationTendance,
      icon: faCrown
    }
  ];

  const selectFormationData = formationsData.filter(
    (formation) => formation.type === sections[selectSection].type
  );

  return (
    <section className="formations-section" id="formations">
      <h2>Nos formations</h2>
      <p>
        Nos formations d'experts, animées par des praticiens chevronnés, vous
        ouvrent les portes d'un monde de compétences. En petits groupes, nos
        formations en gestion transversale assurent une expérience immersive et
        opérationnelle pour votre carrière. Nos formateurs, axés sur une écoute
        bienveillante, personnalisent chaque apprentissage pour répondre à vos
        besoins. Nos programmes constamment actualisés abordent les défis
        contemporains avec des cas pratiques et des mises en situation réelles,
        renforcés par des séances de coaching intégrées. Transformez
        l'acquisition de connaissances en réussite professionnelle palpable.
      </p>
      <div className="formation-sections-container">
        {sections.map((section, index) => (
          <div
            className={clsx(
              "formation-section",
              selectSection === index ? "formation-section-selected" : ""
            )}
            key={"x-" + index}
            onClick={() => setSelectSection(index)}
          >
            <div className="formation-section-icon-container">
              <FontAwesomeIcon icon={section.icon} />
            </div>
            <span>{section.label}</span>
          </div>
        ))}
      </div>
      <div>
        <div className="formation-cells-container">
          {selectFormationData.map((formation, index) => (
            <FormationCell
              key={index}
              image={formation.image}
              title={formation.title}
              description={formation.description}
              id={formation.id}
              content={formation.content}
              type={formation.type}
              sectionType={"formation"}
              onOpenIndicateursPerformanceModal={() =>
                openIndicateursPerformanceModal(formation.type, formation.id)
              }
              onOpenFinancementsModal={() =>
                openFinancementsModal(formation.type)
              }
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FormationsSection;
